// Module
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import dompurify from 'dompurify';
import moment from 'moment';
import 'moment/locale/ko';
import axios from 'axios';
// CSS
import '_Asset/css/User/Page/addition.css';
// Component
import { useEffect, useState } from 'react';
import { Pagination } from 'User/Component';
// API
import { IncruitApi, JoinListApi, JoinPostApi } from '_Route/Api';


// 영문 날짜 format
const FormatConv = (date) => {
  const newDate = new Date(date);

  const month = newDate.toLocaleString("en-US", { month: "long" })
  const dt = newDate.getDate();
  const year = newDate.getFullYear();

  return (month + ' ' + dt + ', ' + year)
}


/*========================================================================
* 개발자 채용 목록 리스트 Component
========================================================================*/
const EmployList = ({item}) => {
  
  const navigate = useNavigate()
  const movePage = () => {
    navigate(`/addition/developer-employ/list/${item.incruit_uuid}`)
  }

  return (
    <li onClick={movePage}>
      <div className="flexBox between">
        <div className="titGroup">
          <h2>[{item.incruit_cat}] {item.incruit_title}</h2>

          <div className="tagGroup">
            {JSON.parse(item.incruit_tag).map((tag, i) =>
              <span key={i}>{tag}</span>
            )}
          </div>
        </div>

        <span>모집기간 : {moment(item.incruit_start_date).format('YYYY.MM.DD')} ~ {moment(item.incruit_last_date).format('YYYY.MM.DD')}</span>
      </div>
    </li>
  )
}

const Skeleton = ({num}) => {
  const result = [];

  for (let i = 0; i < num; i++) {
    result.push(
      <li key={i} className="skeleton">
        <div className="flexBox between">
          <div className="titGroup">
            <h2>[경력] Server 백엔드 개발자 모집</h2>
            <span>#Back-end</span>
          </div>

          <p>모집기간 : 2022.07.27 ~ 2022.07.30</p>
        </div>
      </li>
    )
  }
  return result;
}


const DvlpEmploy = () => {

  // use Module
  const { t } = useTranslation();
  const params = useParams();
  const sanitizer = dompurify.sanitize;
  const navigate = useNavigate();


  // 검색 요청 data
  const [searchTit, setSearchTit] = useState(params.key || '');
  const [searchTag, setSearchTag] = useState();
  const [curPage, setCurPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [blockSize, setBlockSize] = useState(10);

  const [searchRes, setSearchRes] = useState([]);
  const [searchInfo, setSearchInfo] = useState([]);

  const [tabIdx, setTabIdx] = useState(0);
  const [currentPost, setCurrentPost] = useState('');
  const [loading, setLoading] = useState(false);
  const location = useLocation()

  const tabArr = [
    { name: '전체'},
    { name: '신입'},
    { name: '경력'},
    { name: '인턴'},
  ]

  const onKeyPress = (e) => { if(e.key == 'Enter') onSearch(); }
  const onSearch = () => {
    navigate(`/addition/developer-employ${searchTit === '' || searchTit === undefined ? '' : '/' + encodeURIComponent(searchTit)}`);
  }
  

  // 검색 및 페이징 API 요청
  useEffect(() => {
    axios.get(IncruitApi, {
      params: {
        incruit_title: params.key === undefined ? '' : params.key,
        incruit_tag: '',
        incruit_experience: tabArr[tabIdx].name === '전체' ? '' : tabArr[tabIdx].name,
        curPage: curPage,
        pageSize: pageSize,
        blockSize: blockSize,
      }
    })
    .then(res => {
      setSearchInfo(res.data.pageInfo);
      setSearchRes(res.data.result);
      setLoading(true);
    })
    .catch(err => {
      console.error(err, "ERROR...")
      setLoading(true);
    })
  }, [tabIdx, location, curPage])

  
  // Prev, Next Button Event
  const itemIdx = searchRes.findIndex(key => key.incruit_uuid == params.id);
  
  const prevBtn = () => {
    if (itemIdx === 0) {
      navigate(`/addition/developer-employ`);
    } else {
      navigate(`/addition/developer-employ/list/${searchRes[itemIdx - 1].incruit_uuid}`);
    }
  }
  const nextBtn = () => {
    navigate(`/addition/developer-employ/list/${searchRes[itemIdx + 1].incruit_uuid}`);
  }
  
  useEffect(() => {
    if(params.id) {
      setCurrentPost(searchRes.find(key => key.incruit_uuid === params.id));
    }
  })
  
  
  /*========================================================================
  * Pop Up 관련 Data
  ========================================================================*/
  const [popUpState, setPopUpState] = useState(false); // 팝업 열림 여부
  const [page, setPage] = useState(1); // 현재 PopUp 페이지
  const [successCheck, setSuccessCheck] = useState(''); // 페이지 Data Check Success 여부
  const [supportData, setSupportData] = useState([]); // 지원하기 전체 Data 

  // Page 1 Data
  const [checkList, setCheckList] = useState([ // 개인, 민간정보 동의
    {key: 'checkPi', name: 'join_privacy', title: '개인정보', content: ` <h2>1. 개인정보의 수집 및 이용 목적</h2> - 입사전형 진행, 입사지원서 수정, 자격요건의 확인, 합격여부 확인, 지원자와의 원활한 의사소통 경로 확보, 특정금융정보법에 따른 신원확인

    <h2>2. 수집하는 개인정보의 항목</h2> - 필수정보 : 성명, 입사 지원 수정용 비밀번호, 이메일 주소, 전화번호, 생년월일, 성별, 국적, 학력사항(학교명, 입학/졸업년월, 전공, 세부전공, 성적, 졸업구분), 경력사항(회사명, 직무, 직위, 부서명, 재직기간), 병역사항, 보훈사항(대상인 경우), 장애사항(대상인 경우)
    - 선택정보 : 경력사항(신입인 경우), 자격/어학사항(자격 종류, 등급, 점수, 취득일), 봉사활동(신입인 경우)

    <h2>3. 개인정보의 보유 및 이용기간</h2> - 입사지원자의 개인정보는 회사의 인력풀에 저장되어 채용이 필요한 경우 해당 인력풀에서 상시채용을 위해 5년 동안 보관합니다.
    - 다만, 입사지원자가 개인정보의 삭제를 원하는 경우 지체 없이 해당 정보를 삭제합니다.
    
    <h2>4. 동의를 거부할 권리 및 동의 거부에 따른 불이익</h2> - 지원자는 개인정보의 수집, 이용 등과 관련한 위 사항에 대하여 원하지 않는 경우 동의를 거부할 수 있습니다.
    - 다만, 수집하는 개인정보의 항목에서 필수정보에 대한 수집 및 이용에 대하여 동의하지 않는 경우는 채용전형에 제한이 있을 수 있습니다.
    `, state: false},
    {key: 'checkSi', name: 'join_sensitive', title: '민감정보', content: ` <h2>1. 수집 및 이용 목적</h2> - 장애인 고용촉진 및 직업재활법에 따른 장애인 우대

    <h2>2. 수집하는 민감정보 항목</h2> - 장애사항(장애구분)

    <h2>3. 민감정보의 보유 및 이용기간</h2> - 해당 정보는 다른 개인정보 항목과 함께 회사의 인력풀에 저장되어 채용이 필요한 경우 해당 인력풀에서 상시채용을 위해 5년 동안 보관합니다.
    - 다만, 입사지원자가 개인정보의 삭제를 요청하는 경우 지체 없이 이를 삭제합니다.
    
    <h2>4. 동의를 거부할 권리 및 동의 거부에 따른 불이익</h2> - 지원자는 개인정보의 수집, 이용 등과 관련한 위 사항에 대하여 원하지 않는 경우 동의를 거부할 수 있습니다.
    - 다만, 수집하는 개인정보의 항목에서 필수정보에 대한 수집 및 이용에 대하여 동의하지 않는 경우는 채용전형에 제한이 있을 수 있습니다.
    `, state: false}
  ])
  const onChekedElement = (checked, idx) => {
    checkList[idx]['state'] = checked;
    setCheckList([...checkList]);
  }


  // Page 2 Data
  const [curAncestry, setCurAncestry] = useState(''); // 내/외국인 구분
  const radioList = [
    {value: '0', name: '내국인'},
    {value: '1', name: '외국인/재외교포'},
  ]
  const [curName, setCurName] = useState(''); // 성명
  const [curBirth, setCurBirth] = useState(''); // 생년월일
  const [curGender, setCurGender] = useState(''); // 성별
  const [curPass, setCurPass] = useState(''); // 비밀번호
  const [curRePass, setCurRePass] = useState(''); // 비밀번호 확인
  const [curEmail, setCurEmail] = useState(''); // 이메일 아이디
  const [emailUrl, setEmailUrl] = useState('naver.com'); // 선택된 이메일 주소
  const [readOnlyState, setReadOnlyState] = useState(true); // 이메일 직접선택 시 false
  // onChange Email Data
  const onChangeEmail = (e) => {
    setEmailUrl(e.target.value);

    if (e.target.value === '') {
      setReadOnlyState(false);
    } else {
      setReadOnlyState(true);
    }
  }


  // Page 3 Data
  const [joinTit, setJoinTit] = useState(''); // 지원 제목
  const [joinContent, setJoinContent] = useState(''); // 지원 내용
  const [uploadFile, setUploadFile] = useState(''); // 이력서 첨부 File
  

/*========================================================================
* Pop Up 관련 Function
========================================================================*/
  const curMsg = (inputItem, selectItem, inputName, selectName) => {
    let msg; // 오류 Message
    let state = false;
    let regPass = /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,25}$/; // 영문 숫자 조합 8~20자리

    if (inputItem === '' || (inputItem == 0 && inputName === '약관')) {
      msg = `${inputName}을 입력해주세요.`
    }
    else if (selectItem === '') {
      msg = `${selectName}을 선택해주세요.`
    }
    else if (inputItem.length !== 8 && inputName === '생년월일') {
      msg = `${inputName} 입력 형식이 다릅니다.`
    }
    else if (regPass.test(inputItem) === false && inputName === '비밀번호') {
      msg = '영문 숫자 조합 8-20자리'
    } else { state = true }

    return {msg: msg, state: state}
  }


  // 입력 데이터 배열 저장
  const saveData = (e) => {
    const tgName = e.target.name
    const tgValue = tgName === 'file' ? e.target.files[0] : e.target.value

    const findCurItem = supportData.find(key => key.name === tgName)

    let tgTxt;
    if(tgName === 'join_birth') tgTxt = '생년월일'
    else if (tgName === 'join_pass') tgTxt = '비밀번호'
    else if (tgName === 'join_privacy' || tgName === 'join_sensitive') tgTxt = '약관'

    if(tgName !== '') {
      if (findCurItem) {
        findCurItem['value'] = tgValue;
        findCurItem['state'] = curMsg(tgValue, null, tgTxt).state;
      } else {
        setSupportData([...supportData, Object.assign({name: tgName}, {value: tgValue}, {page: page}, {state: curMsg(tgValue, null, tgTxt).state})]);
      }
    }
  }


  // Popup Paging / Success Check
  const pageFunc = () => {
    let successNum;
    successNum = supportData.filter(key => key.state && key.page === page);

    if ((successNum.length === 2 && page === 1) || (successNum.length === 6 && curPass === curRePass && page === 2)) {
      setPage(page + 1)
      setSuccessCheck(true)
    }
    else if (successNum.length === 3 && page === 3) {
      sendSupport()
      setSuccessCheck(true)
    }
    else {
      setSuccessCheck(false)
    }
  }
  

  useEffect(() => {
    if (popUpState === false) { // 팝업 종료시 초기 세팅으로
      setSuccessCheck('')
      setSupportData([])
      setPage(1)
      setCurAncestry('')
      setCurBirth('')
      setCurPass('')
      setCurEmail('')
      setEmailUrl('naver.com')
      setUploadFile('')
      checkList.map(key => key['state'] = false)
    }
  }, [popUpState])


  // 지원하기 POST API
  const sendSupport = () => {

    let formData = new FormData();

    formData.append("incruit_uuid", params.id);
    supportData.map(data => formData.append(data.name, data.value))
    formData.set("join_email", curEmail + '@' + emailUrl)
    
    axios({
      method: 'post',
      url: JoinPostApi,
      data: formData,
    })
    .then(res => {
      alert("지원이 완료되었습니다.")
      navigate("/addition/developer-employ")
      setPopUpState(false)
    })
    .catch(err => {
      console.error("ERROR", err)
      alert(err.response.data.message);
      setPopUpState(false)
    })
  }


/*========================================================================
* 지원 내역 확인 Popup
========================================================================*/
  const [historyData, setHistoryData] = useState();
  const joinSearch = () => {
    axios({
      method: 'post',
      url: JoinListApi,
      data: {
        join_email: curEmail + '@' + emailUrl,
        join_pass: curPass,
      }
    })
    .then(res => {
      setHistoryData(res.data.result)
      // localStorage.setItem("joinStatus", true)
      setPage(5)
    })
    .catch(err => {
      console.error('ERROR...', err)
      alert(err.response.data.message)
    })
  }

  const joinHistory = () => {
    setPopUpState(true);
    setPage(4);
  }

  const statusChk = (item) => {
    let msg;
    let state;

    if (item === 0) {msg = '진행중'; state = 'progress'}
    else if (item === 1) {msg = '합격'; state = 'pass'}
    else if (item === 2) {msg = '불합격'; state = 'fail'}
    else if (item === 3) {msg = '모집기간 종료'; state = 'end'}

    return {msg: msg, state: state}
  }


  return (
    <>
      {/* Visual */}
      <div className="visual addition">
        <div className="section">
          <div className="visualTitGroup">
            <h2 className="visualTit">개발자 채용</h2>

            <p className="visualTxt">
              전 세계 수억명이 이용 중인 세이퍼트 서비스를 금융 소외계층 없이 더욱 편리하게 이용할 수 있도록 만들어갑니다.
              다양한 생각을 자유롭게 나누며, 언제나 놀라운 결과를 만들어 냅니다.
              각 분야의 실력 있는 개발자들이 모여 도전적인 목표를 향해 나아갈 수 있습니다.
            </p>
          </div>
        </div>
      </div>

      <div className="mainContents">
        <div className="section">
          <div className="employArea areaBox">
            <div className="flexBox between">
              <div className="tabGroup type_2_bg sfrtBlue round_100">
                <div className="tabBar">
                  {
                    tabArr.map((key, i) => 
                      <button type="button" key={i} className={`btn sm ${tabIdx === i ? 'active' : ''}`} onClick={() => {setTabIdx(i); navigate('/addition/developer-employ')}}>{key.name}</button>
                    )
                  }
                </div>
              </div>
              
              <div className="fieldWrap">
                <div className="fieldGroup mainSearch">
                  <div className="field">
                    <input type="input" className="input md" placeholder="검색어를 입력해주세요." onChange={(e) => setSearchTit(e.target.value)} onKeyPress={onKeyPress} value={searchTit} />
                    <button type="button" className="btn sm sfrtBlue i_only" onClick={onSearch}><i className="icofont-search"></i></button>
                  </div>
                </div>

                <button type="button" className="btn sm sfrtBlue round_10" onClick={joinHistory}>지원 내역 보기</button>
              </div>
            </div>

            {
              params.id === undefined ?
                loading ?
                  searchRes.length !== 0 ?
                  <>
                    <ul>
                      {searchRes.map((key, i) => <EmployList key={i} item={key} />)}
                    </ul>

                    <div className="flexBox center">
                      <Pagination
                        type="type_2"
                        size="lg"
                        curPage={curPage}
                        setCurPage={setCurPage}
                        pageSize={pageSize}
                        blockSize={blockSize}
                        startBlock={searchInfo.startBlock}
                        endBlock={searchInfo.endBlock}
                        pageCount={searchInfo.pageCount}
                      />
                    </div>
                  </>
                  :
                  <div className="noDataBox">
                    <i className="icofont-warning-alt"></i>
                    <p>No results found for <span>{params.key}</span>.<br /> Please enter another search term.</p>
                  </div>
                :
                <ul>
                  <Skeleton num={10} />
                </ul>
              :
              <>
                {
                  currentPost &&
                  <div className="employBox">
                    <div className="flexBox between">
                      <div className="titGroup">
                        <Link to="/addition/developer-employ" className="icofont-navigation-menu"></Link>

                        <h2>[{currentPost.incruit_cat}] {currentPost.incruit_title}</h2>
                      </div>

                      <div className="subGroup">
                        <span>모집기간 : {`${moment(currentPost.incruit_start_date).format('YYYY.MM.DD')} ~ ${moment(currentPost.incruit_last_date).format('YYYY.MM.DD')}`}</span>
                        
                        <div className="btnGroup">
                          <button type="button" className="icofont-caret-left" onClick={prevBtn}></button>
                          <button type="button" className="icofont-caret-right" onClick={nextBtn}></button>
                        </div>
                      </div>
                    </div>

                    <div className="contArea">
                      <div className="flexBox between">
                        <div className="tagGroup">
                          {JSON.parse(currentPost.incruit_tag).map((tag, i) =>
                            <span key={i}>{tag}</span>
                          )}
                        </div>
                        <span>{`등록일 ${FormatConv(currentPost.incruit_create_date)}`}</span>
                      </div>

                      <p dangerouslySetInnerHTML = {{ __html: sanitizer(currentPost.incruit_content)}}></p>
                    </div>
                  </div>
                }

                <div className="btnArea">
                  <button type="button" className="btn sm round_10 sfrtBlue" onClick={() => setPopUpState(true)}>지원하기</button>
                </div>
              </>
            }
          </div>
        </div>
      </div>

      {/* 입사 지원하기 PopUp */}
      <div className={`modal employ ${popUpState ? 'show' : ''}`} onChange={(e) => saveData(e)}>
        {
          page === 1 && // 개인정보 수집 및 이용에 대한 안내 Page
          <div className="modalBox page_1">
            <div className="modalHeader">
              <h2>개인정보 수집 및 이용에 대한 안내</h2>
            </div>

            <div className="modalBody">
              <fieldset>
                <legend>정보 수집 및 동의</legend>

                {/* 개인정보, 민감정보 수집 및 이용 동의 Field */}
                {checkList.map((list, i) => 
                  <div key={i} className="fieldGroup">
                    <label>{list.title}의 수집 및 이용 동의</label>

                    <div className="field">
                      <div className="termsBox" dangerouslySetInnerHTML={{ __html: sanitizer(list.content)}}></div>
                    </div>
                    
                    <div className="checkGroup">
                      <input type="checkbox" name={list.name} value={list.state ? '0' : '1'} id={list.key} onChange={e => onChekedElement(e.target.checked, i)}></input>
                      <label htmlFor={list.key}>{list.title}의 수집 및 이용에 동의합니다.</label>
                    </div>
                    {
                      successCheck === false && !checkList[i].state &&
                      <p className="fieldTxt error"><i className="icofont-warning-alt"></i>약관에 동의해 주세요.</p>
                    }
                  </div>
                )}
              </fieldset>
            </div>

            <div className="modalFoot">
              <button type="button" className="btn sm round_10 sfrtBlue" onClick={pageFunc}>동의</button>
              <button type="button" className="btn sm round_10 black_edge" onClick={() => setPopUpState(false)}>동의하지 않습니다</button>
            </div>
          </div>
        }
        {
          page === 2 && // 입사 지원하기 - 개인정보 입력
          <div className="modalBox page_2">
            <div className="modalHeader">
              <h2>입사 지원하기 - 개인정보 입력</h2>
            </div>

            <div className="modalBody">
              <fieldset>
                <legend>개인정보 입력</legend>

                {/* 내/외국인 구분 Field */}
                <div className="fieldGroup row">
                  <label>내/외국인 구분</label>

                  <div className="field">
                    {radioList.map((key, i) => 
                      <div className="checkGroup" key={i}>
                        <input type="radio" name="join_foreigner" id={key.value} value={key.value} checked={curAncestry === key.value} onChange={(e) => setCurAncestry(e.target.value)}></input>
                        <label htmlFor={key.value}>{key.name}</label>
                      </div>
                    )}
                  </div>
                  {
                    successCheck === false && curAncestry === '' &&
                    <p className="fieldTxt error"><i className="icofont-warning-alt"></i>항목을 선택해주세요.</p>
                  }
                </div>

                {/* 성명 Field */}
                <div className="fieldGroup row">
                  <label>성명</label>

                  <div className="field">
                    <input type="text" name="join_name" className="input sm round_10" onChange={(e) => setCurName(e.target.value)} placeholder="이름을 입력해주세요."></input>
                  </div>
                  {
                    successCheck === false && curName === '' &&
                    <p className="fieldTxt error"><i className="icofont-warning-alt"></i>이름을 입력해주세요.</p>
                  }
                </div>

                {/* 생년월일 / 성별 Field */}
                <div className="fieldGroup row">
                  <label>생년월일/성별</label>

                  <div className="field gap">
                    <input type="text" name="join_birth" className="input sm round_10" placeholder="예) 1988.01.01" value={curBirth.replace(/[^0-9.]/g, '')} onChange={(e) => setCurBirth(e.target.value)} maxLength={8}></input>
                    <select name="join_gender" className="select round_10 sm type_1" onChange={(e) => setCurGender(e.target.value)}>
                      <option value="">선택</option>
                      <option value="0">남자</option>
                      <option value="1">여자</option>
                    </select>
                  </div>
                  {
                    successCheck === false && !curMsg(curBirth, curGender, '생년월일', '성별').state &&
                    <p className="fieldTxt error"><i className="icofont-warning-alt"></i>{curMsg(curBirth, curGender, '생년월일', '성별').msg}</p>
                  }
                </div>

                {/* 이메일 Field */}
                <div className="fieldGroup row">
                  <label>이메일</label>

                  <div className="field gap">
                    {/* field wrap으로 감싸기 */}
                    <input type="text" name="join_email" className="input sm round_10" onChange={e => setCurEmail(e.target.value)} placeholder="이메일 입력"></input>
                    <span>@</span>
                    <input type="text" name="join_email" className="input sm round_10" value={emailUrl} onChange={(e) => setEmailUrl(e.target.value)} readOnly={readOnlyState ? true : false}></input>

                    <select className="select round_10 sm type_1" name="join_email" onChange={(e) => onChangeEmail(e)}>
                      <option value="naver.com">네이버</option>
                      <option value="gmail.com">지메일</option>
                      <option value="daum.net">다음</option>
                      <option value="hanmail.net">한메일</option>
                      <option value="hotmail.com">핫메일</option>
                      <option value="nate.com">네이트</option>
                      <option value="yahoo.com">야후</option>
                      <option value="">직접입력</option>
                    </select>
                  </div>
                  {
                    successCheck === false && curEmail === '' &&
                    <p className="fieldTxt error"><i className="icofont-warning-alt"></i>이메일을 입력해주세요.</p>
                  }
                </div>

                {/* 비밀번호 Field */}
                <div className="fieldGroup row">
                  <label>비밀번호</label>

                  <div className="field">
                    <input type="password" name="join_pass" className="input sm round_10" placeholder="숫자, 영문 혼합하여 8자 이상" onChange={(e) => setCurPass(e.target.value)} maxLength={20}></input>
                  </div>
                  {
                    successCheck === false && !curMsg(curPass, null, '비밀번호').state &&
                    <p className="fieldTxt error"><i className="icofont-warning-alt"></i>{curMsg(curPass, null, '비밀번호').msg}</p>
                  }
                </div>

                {/* 비밀번호 확인 Field */}
                <div className="fieldGroup row">
                  <label>비밀번호 확인</label>

                  <div className="field">
                    <input type="password" className="input sm round_10" onChange={(e) => setCurRePass(e.target.value)} maxLength={20} placeholder="비밀번호를 다시 한번 입력해주세요."></input>
                  </div>
                  {
                    successCheck === false && curPass !== curRePass &&
                    <p className="fieldTxt error"><i className="icofont-warning-alt"></i>비밀번호가 서로 다릅니다.</p>
                  }
                </div>
              </fieldset>

              <div className="txtGroup">
                <p className="point subMsg">이메일 주소는 지원 내역 확인 시 필요하므로 오타가 없는지 확인하시기 바랍니다.</p>
                <p className="point subMsg">비밀번호, 이메일은 대소문자를 구분하므로 입력 시에 주의하시기 바랍니다.</p>
              </div>
            </div>

            <div className="modalFoot">
              <button type="button" className="btn sm round_10 sfrtBlue" onClick={pageFunc}>확인</button>
              <button type="button" className="btn sm round_10 black_edge" onClick={() => setPopUpState(false)}>닫기</button>
            </div>
          </div>
        }
        {
          page === 3 && // 입사 지원하기
          <div className="modalBox page_3">
            <div className="modalHeader">
              <h2>입사 지원하기</h2>
            </div>

            <div className="modalBody">
              <fieldset>
                <legend>Support Request Form</legend>

                {/* 제목 Field */}
                <div className="fieldGroup">
                  <label htmlFor="">제목<span className="redTxt">*</span></label>
                  
                  <div className="field">
                    <input type="text" name="join_title" className="input md round_10" placeholder="지원 제목을 입력해주세요." onChange={(e) => setJoinTit(e.target.value)}></input>
                  </div>
                  {
                    successCheck === false && joinTit === '' &&
                    <p className="fieldTxt error"><i className="icofont-warning-alt"></i>지원 제목을 입력해주세요.</p>
                  }
                </div>

                {/* 내용 Field */}
                <div className="fieldGroup">
                  <label htmlFor="">내용<span className="redTxt">*</span></label>
                  
                  <div className="field">
                    <textarea name="join_content" className="textarea round full" placeholder="지원 내용을 입력해주세요." onChange={(e) => setJoinContent(e.target.value)}></textarea>
                  </div>
                  {
                    successCheck === false && joinContent === '' &&
                    <p className="fieldTxt error"><i className="icofont-warning-alt"></i>지원 내용을 입력해주세요.</p>
                  }
                </div>

                {/* 이력서 첨부 Field */}
                <div className="fieldGroup">
                  <label htmlFor="">이력서 첨부<span className="redTxt">*</span></label>
                  
                  <div className="field">
                    <label className={`input md full file type_1 round_10 ${uploadFile ? 'active' : ''}`} htmlFor="inputFile">{uploadFile ? uploadFile.name : '업로드할 파일을 선택해주세요.'}<i className="icofont-link"></i></label>
                    <input type="file" id="inputFile" name="file" className="file" accept=".xlsx, .docx, .pptx, .pdf, .hwp" onChange={(e) => setUploadFile(e.target.files[0])}></input>
                  </div>
                  <p className="fieldTxt info">파일명은 반드시 '백엔드개발_홍길동'으로 작성해주세요.</p>
                  {
                    successCheck === false && uploadFile === '' &&
                    <p className="fieldTxt error"><i className="icofont-warning-alt"></i>이력서를 첨부해주세요.</p>
                  }
                </div>
              </fieldset>
            </div>

            <div className="modalFoot">
              <button type="button" className="btn sm sfrtBlue round_10" onClick={pageFunc}>지원하기</button>
              <button type="button" className="btn sm black_edge round_10" onClick={() => setPopUpState(false)}>닫기</button>
            </div>
          </div>
        }
        {
          page === 4 && // 입사 내역 확인 - 이메일, 비밀번호 입력 PopUp
          <div className="modalBox page_4">
            <div className="modalHeader">
              <h2>지원 내역 확인</h2>
            </div>

            <div className="modalBody">
              <h2 className="modalBodyTit center">지원 시 입력했던 이메일과 비밀번호를 입력해주세요.</h2>

              <fieldset>
                <legend>지원 내역 확인</legend>

                {/* 이메일 Field */}
                <div className="fieldGroup row">
                  <label>이메일</label>

                  <div className="field gap">
                    {/* field wrap으로 감싸기 */}
                    <input type="text" name="join_email" className="input sm round_10" onChange={e => setCurEmail(e.target.value)}></input>
                    <span>@</span>
                    <input type="text" name="join_email" className="input sm round_10" value={emailUrl} onChange={(e) => setEmailUrl(e.target.value)} readOnly={readOnlyState ? true : false}></input>

                    <select className="select round_10 sm type_1" name="join_email" onChange={(e) => onChangeEmail(e)}>
                      <option value="naver.com">네이버</option>
                      <option value="gmail.com">지메일</option>
                      <option value="daum.net">다음</option>
                      <option value="hanmail.net">한메일</option>
                      <option value="hotmail.com">핫메일</option>
                      <option value="nate.com">네이트</option>
                      <option value="yahoo.com">야후</option>
                      <option value="">직접입력</option>
                    </select>
                  </div>
                </div>

                {/* 비밀번호 Field */}
                <div className="fieldGroup row">
                  <label>비밀번호</label>

                  <div className="field">
                    <input type="password" name="join_pass" className="input sm round_10" onChange={(e) => setCurPass(e.target.value)} onKeyPress={(e) => {if(e.key == 'Enter') joinSearch()}} maxLength={20}></input>
                  </div>
                </div>
              </fieldset>
            </div>

            <div className="modalFoot">
              <button type="button" className="btn sm sfrtBlue round_10" onClick={joinSearch}>확인</button>
              <button type="button" className="btn sm black_edge round_10" onClick={() => setPopUpState(false)}>취소</button>
            </div>
          </div>
        }
        {
          page === 5 && // 입사 내역 확인 PopUp
          <div className="modalBox page_5">
            <div className="modalHeader">
              <h2>지원 내역 확인</h2>
            </div>

            <div className="modalBody">
              <div className="flexBox between modalBodyTit">
                <h2><span>{historyData[0].join_name}({historyData[0].join_email})</span> 님의 지원 내역입니다.</h2>

                <p>총 지원 내역: <span>{historyData.length}</span>건</p>
              </div>

              <div className="table list_2">
                <table>
                  <thead>
                    <tr>
                      <th>채용 글 제목</th>
                      <th>태그</th>
                      <th>모집기간</th>
                      <th>지원 날짜</th>
                      <th>지원 상태</th>
                      <th>지원 글 보기</th>
                    </tr>
                  </thead>

                  <tbody>
                    {historyData.map((key, i) =>
                      <tr key={i}>
                        <td>{key.incruit_title}</td>
                        <td>{JSON.parse(key.incruit_tag).map((tag, i) => `${tag}${i !== JSON.parse(key.incruit_tag).length - 1 ? ', ' : ''}`)}</td>
                        <td>{`${moment(key.incruit_start_date).format('YYYY.MM.DD HH:mm')} ~ ${moment(key.incruit_last_date).format('YYYY.MM.DD HH:mm')}`}</td>
                        <td>{moment(key.join_date).format('YYYY.MM.DD HH:mm')}</td>
                        <td><label className={statusChk(key.join_status).state}>{statusChk(key.join_status).msg}</label></td>
                        <td><button type="button" className="btn xs round_10 sfrtBlue" onClick={() => {navigate(`/addition/developer-employ/list/${key.incruit_uuid}`); setPopUpState(false); setTabIdx(0)}}>지원 글 확인</button></td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="modalFoot">
              <button type="button" className="btn sm sfrtBlue round_10" onClick={() => setPopUpState(false)}>닫기</button>
            </div>
          </div>
        }
      </div>
    </>
  )
}

export default DvlpEmploy